import "./Hero.scss";
//import "./Features.scss";
import { IoCloseCircleOutline, IoSearch } from "react-icons/io5";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import { Songbook } from "../../../@core/models";
import debounce from "lodash/debounce";
import RestClient from "../../../@core/restClient";
import Spinner from "../UI/Spinner";

const Hero = () => {
  const queryRef = useRef<any>();
  const [query, setQuery] = useState<string>("");
  const [selectedSongbookId, setSelectedSongbookId] = useState<number | null>(
    null
  );
  const [songbooks, setSongbooks] = useState<Songbook[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const deferredSetQueryHandler = useCallback(
    debounce((event: React.ChangeEvent<HTMLInputElement>) => {
      setQuery(event.target.value);
    }, 800),
    []
  );

  useEffect(
    function () {
      (async () => {
        if (
          queryRef.current !== document.activeElement ||
          queryRef.current.value !== query
        ) {
          return;
        }
        try {
          // setIsLoading(true);
          const response = await RestClient.getSongbookList(query);
          setSongbooks(response || []);
          //setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      })();
    },
    [query, isOpen]
  );

  const selectSongbook = (songbook: Songbook) => {
    queryRef.current.value = songbook.title;
    setQuery(songbook.title);
    setSelectedSongbookId(songbook.id);
    setSongbooks([]);
    navigate(`/songbook/${songbook.id}`);
    window.scrollTo(0, 0);
    setQuery("");
    setIsOpen(false);
  };

  const openAgain = (e: any) => {
    e.stopPropagation();
    queryRef.current.value = "";
    setIsOpen(true);
    console.log("state of open", isOpen);
  };
  useEffect(() => {
    if (isOpen) {
      document.body.addEventListener("click", () => {
        setIsOpen(false);
      });
    } else {
      return;
    }
  }, [isOpen]);

  return (
    <div className="hero">
      <div className="hero-small-text">Завжди під рукою</div>
      <h1 className="title">
        <span>ARYN Lyrics</span>
        <br />
        Відкривай та
        <br />
        Співай!
      </h1>
      <div className="choose-book">
        <div className="box-open-btn">
          {isLoading ? <Spinner /> : null}
          <IoSearch className="search-icon" />
          <input
            className="box-open-btn-input"
            type="text"
            ref={queryRef}
            placeholder="Введіть назву збірника"
            onChange={deferredSetQueryHandler}
            onClick={(e) => openAgain(e)}
          />
          {songbooks?.length > 0 && isOpen && (
            <div className="select-container_two">
              <IoCloseCircleOutline
                className="close_two"
                onClick={() => setIsOpen(false)}
              />
              {songbooks?.map((songbook: Songbook, index: number) => (
                <div
                  className="select-item_two"
                  key={index}
                  onClick={() => selectSongbook(songbook)}
                >
                  {songbook.title}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="hero-img-container">
        <div className="hero-img-group">
          <div className="hero-img-1">
            <img src="/images/home-musician3.jpg" alt="home-musician3" />
          </div>
          <div className="hero-img-2">
            <img src="/images/home-musician4.jpg" alt="home-musician4" />
          </div>
          <div className="hero-img-3">
            <img src="/images/home-band.jpg" alt="home-band" />
          </div>
          <div className="geo-form"></div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
